export default __webpack_public_path__ + "static/media/PokeHuddle-Title.1c41dbaf.png";